import { ARSTActionLoadData, ArsTableState } from "../interface";
import { computeUsedGroupingFactorIds } from "./computeUsedGroupingFactorIds";

/**
 * Replaces the current table body with freshly loaded data.
 *
 * @param state - Current ARS table state
 * @param action - Load action containing replacement body data
 * @returns Updated ARS table state
 */
export const arst_loadData = <T>(
  state: ArsTableState<T>,
  action: ARSTActionLoadData<T>,
): ArsTableState<T> => ({
  ...state,
  bodyData: action.bodyData,
  usedGroupingFactorIds: computeUsedGroupingFactorIds(action.bodyData),
  changed: false,
});
